<template>
<div class="container">
    <div class="row" style="margin-top: 20px">
        <div class="col-md-12">
            <member-card-check />
        </div>
        <div class="col-md-12" style="margin-top: 20px" v-if="apiKey">
            <member-card-check-docs :api-key="apiKey" />
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            apiKey: this.$store.getters.getUserData.apiKey
        }
    },
    components: {
        'member-card-check': require('../components/memberCardCheck.vue').default,
        'member-card-check-docs': require('../components/memberCardCheckDocumentation.vue').default,
    }
}
</script>
